import { Component, OnInit } from '@angular/core';
import { ApiHandlerService } from '../api-handler.service'
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.css']
})
export class ResourcesComponent implements OnInit {

  constructor(private apiHandler: ApiHandlerService, private router: ActivatedRoute, private route: Router) {
   
   }

  resourceTitle = "Blogs"
  resourcePath = "all"
  menuArray = [];
  posts = [];
  page=1;
  limit=12;
  maxPost = 0;
  searchItem = null;
  searchTags = [];
  isLoading = false;

  ngOnInit() {
    console.log("---nGONINIT--")
    this.getMenuList();
    this.validateParams();   
    window.addEventListener('scroll', this.scroll, true);     
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.scroll, true);
  }

  validateParams(){
    this.router.params.subscribe(prm=>{
      console.log("---- PARAMS -----")
      this.router.queryParams.subscribe(qprm=>{
        console.log("---- QUERY -----")
        // console.log("qprm>>",qprm)
        this.resourcePath = prm['id'] != undefined? prm['id']:'all';
        let input = {type:this.resourcePath}
        if(qprm['tag'] != undefined){
          input['tags'] = [qprm['tag']]
          this.searchTags = [qprm['tag']]
        }
        this.getPosts(input) 
      })       
    })  
    
  }

  getPostListFromHeader(path){
    console.log("----getPostListFromHeader----")
    this.posts = [];
    this.page = 1;
    this.resourcePath = path.slug;
    console.log("resourcePath >>>", path, this.resourcePath)
    this.markSelectedMenu(path.slug);
    this.getPosts({type:this.resourcePath});
  }

  getMenuList(){
    this.apiHandler.getMenuList().subscribe(
      (result:any) => {        
        let title = ""
        let totalMenu = result.data.length;
        result.data.map((menu,index)=> {
          this.menuArray.push({name: menu.name, slug: menu.slug, isSelected:this.resourcePath==menu.slug?true:false})
          title+=menu.name;
          if(index == totalMenu-2){
            title+=" & "
          }else if(index == totalMenu-1){
            title+="."
          }else{
            title+=", "
          }
        });
        this.resourceTitle = title
        this.menuArray = [{name:"All",slug:'all', isSelected:this.resourcePath=='all'?true:false}].concat(this.menuArray)
        console.log(this.menuArray)
    },
    (err:any)=>{
      console.error("Menu Error ==>", err);
      
    }
    )
  }

  scroll = (event): void => {
    let ele = event.srcElement.scrollingElement;
    if(ele!=undefined && ele.scrollHeight != undefined && ele.scrollHeight - ele.scrollTop <= ele.clientHeight +1000){
      if(this.maxPost == this.limit) {
        this.page++;
        this.getPosts({type:this.resourcePath});
      }
    }
  };

  onSelectFilter(menu){
    this.searchItem = null
    this.searchTags = [];
    this.posts=[];
    let slug = menu.slug?menu.slug:"all"
    this.route.navigate(['/resources/'+slug])
    this.markSelectedMenu(slug);
    //let index = this.menuArray.findIndex((menu)=>menu.slug==slug);
    

    
  }

  markSelectedMenu(slug){
    this.menuArray = this.menuArray.map((menu)=>{
      if(menu.slug == slug){
        menu.isSelected = true
      }else{
        menu.isSelected = false
      }
      return menu
    })
  }

  searchPost(text: string){
    this.page = 1;
    this.posts = []
    this.getPosts({type:this.resourcePath, search:text})
  }

  getPosts(input){
    this.isLoading = true;
    console.log("Calling POST API")
    let data = {...input, page:this.page, limit:this.limit}
    if(this.searchTags.length > 0){
      data['tags'] = this.searchTags
    }
    this.apiHandler.getPosts(data).subscribe(
      (result:any) => {      
        this.isLoading = false;  
       console.log(result)
       this.maxPost = result.data.length
       let list = result.data;
        list.map(post =>{
          const index = this.posts.findIndex(p=>p._id==post._id);
          if(index == -1){
            this.posts.push(post)
          }
        })
    },
    (err:any)=>{
      this.isLoading = false;  
      
    }
    )
  }

  onPostClick(post){
    this.route.navigate(['/resources/'+post.type.slug+"/"+post.slug]).then(()=>{
      
    })
  }


}
